import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import styles from './ActionButton.module.scss';
import Spinner from '../../common/Spinner';

function ActionButton(props) {
  const { disabled, size = 25 } = props;

  let iconClass;

  switch (props.type) {
    case 'import':
      iconClass = 'ic-arrow_upward';
      break;

    case 'export':
    case 'download':
      iconClass = 'ic-email_arrow';
      break;

    default:
      break;
  }

  const onClick = () => {
    if (!disabled) {
      props.onClick();
    }
  };

  const fontSizeStyle = {
    fontSize: `${size}px`,
  };

  if (props.downloading) {
    return <Spinner />;
  }

  return (
    <button
      type="button"
      style={fontSizeStyle}
      onClick={onClick}
      className={cn(styles.actionButton, disabled ? styles.disabled : '')}
      title={props.title}
    >
      <span className={iconClass} />
    </button>
  );
}

export default ActionButton;

ActionButton.defaultProps = {
  size: 25,
  disabled: false,
  downloading: false,
};

ActionButton.propTypes = {
  size: PropTypes.number,
  disabled: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  downloading: PropTypes.bool,
  title: PropTypes.string,
};
